var _defs, _path, _g, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.988,
    height: 20,
    viewBox: "0 0 16.988 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#455079;}.b{stroke:#455079;}.c{stroke:none;}.d{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.162,15.573H19.32a2.663,2.663,0,0,0,2.668-2.636V6.9A2.663,2.663,0,0,0,19.32,4.262H13.784L13.635,3.8A2.677,2.677,0,0,0,11.15,2H7.714A2.7,2.7,0,0,0,5.8,2.759,2.631,2.631,0,0,0,5,4.636v8.3a2.663,2.663,0,0,0,2.668,2.636h6.493Z",
    transform: "translate(-5 -2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(6.974 11.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.888,
    height: 8.494,
    rx: 0.944
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 0.888,
    height: 7.494,
    rx: 0.444
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.101,
    height: 1.888,
    rx: 0.944,
    transform: "translate(0.367 17.169)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.888,
    cy: 1.888,
    r: 1.888,
    transform: "translate(6.03 16.225)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.10b5bbf803105a3f7e94bb5b7c23bb1e.svg";
export { ForwardRef as ReactComponent };